var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-3",attrs:{"no-body":"","type":"dark","bg-variant":"light"}},[_c('b-col',{staticClass:"ml--2"},[_c('h3',{staticClass:"mt-1 ml-1"},[_vm._v("Buchaltung")])])],1),_c('InputCard',{attrs:{"input":{
      headline: 'Buchhaltung Steuerberater (Buchung per Rechnung)',
      row1: {
        text: 'Buchungen / Rechnungen',
        disabledCheck: false,
        icon: 'file-earmark',
        vuexModule: 'Kostentraegermanagment',
        stateObj: 'erstellung',
        value: 'rechnungen',
        mutationName: 'Kostentraegermanagment/updateRechnungen'
      },
      row2: {
        text: 'Gebühr pro Buchung',
        disabledCheck: false,
        icon: 'cash',
        vuexModule: 'Buchhaltung',
        stateObj: 'steuerberater',
        value: 'gebuehren',
        mutationName: 'Buchhaltung/updateGebuehren',
        rowFormat: 'currency'
      },
      row3: {
        text: '',
        disabledCheck: true,
        icon: 'clock',
        value: 'Kostentraegermanagment/gesamtMinPflege',
        mutationName: ''
      },
      row4: {
        text: 'Gesamtkosten',
        disabledCheck: true,
        icon: 'cash-stack',
        value: 'Buchhaltung/gesamtKostenSteuerberater',
        mutationName: ''
      },
      row5: {
        text: 'Kosten pro Beleg',
        disabledCheck: true,
        icon: 'cash',
        value: 'Buchhaltung/kostenBelegSteuerberater',
        mutationName: ''
      }
    }}}),_c('InputCard',{attrs:{"input":{
      headline: 'Überwachung Zahlungseingänge (GKV)',
      row1: {
        text: 'Wie lange dauert es (min.)',
        disabledCheck: false,
        icon: 'clock-history',
        vuexModule: 'Buchhaltung',
        stateObj: 'zahlungseingaenge',
        value: 'dauer',
        mutationName: 'Buchhaltung/updateDauer'
      },
      row2: {
        text: 'Mitarbeiteranzahl',
        disabledCheck: false,
        icon: 'people-fill',
        vuexModule: 'Buchhaltung',
        stateObj: 'zahlungseingaenge',
        value: 'mitarbeiteranzahl',
        mutationName: 'Buchhaltung/updateMitarbeiteranzahl'
      },
      row3: {
        text: 'Gesamt min.',
        disabledCheck: true,
        icon: 'clock',
        value: 'Buchhaltung/gesamtMinZahlungseingaenge',
        mutationName: ''
      },
      row4: {
        text: 'Gesamtkosten',
        disabledCheck: true,
        icon: 'cash-stack',
        value: 'Buchhaltung/gesamtKostenZahlungseingaenge',
        mutationName: ''
      },
      row5: {
        text: 'Kosten pro Beleg',
        disabledCheck: true,
        icon: 'cash',
        value: 'Buchhaltung/kostenBelegZahlungseingaenge',
        mutationName: ''
      }
    }}}),_c('InputCard',{attrs:{"input":{
      headline: 'Höhe Bankbuchungsgebühren (durch Einzelbuchungen)',
      row1: {
        text: 'Buchungen / Rechnungen',
        disabledCheck: false,
        icon: 'file-earmark',
        vuexModule: 'Kostentraegermanagment',
        stateObj: 'erstellung',
        value: 'rechnungen',
        mutationName: 'Kostentraegermanagment/updateRechnungen'
      },
      row2: {
        text: 'Gebühr pro Buchung',
        disabledCheck: false,
        icon: 'cash',
        vuexModule: 'Buchhaltung',
        stateObj: 'bankbuchung',
        value: 'gebuehren',
        mutationName: 'Buchhaltung/updateBankgebuehren',
        rowFormat: 'currency'
      },
      row3: {
        text: '',
        disabledCheck: true,
        icon: 'clock',
        value: 'Kostentraegermanagment/gesamtMinPflege',
        mutationName: ''
      },
      row4: {
        text: 'Gesamtkosten',
        disabledCheck: true,
        icon: 'cash-stack',
        value: 'Buchhaltung/gesamtKostenBankgebuehren',
        mutationName: ''
      },
      row5: {
        text: 'Kosten pro Beleg',
        disabledCheck: true,
        icon: 'cash',
        value: 'Buchhaltung/kostenBelegBankgebuehren',
        mutationName: ''
      }
    }}}),_c('InputCard',{attrs:{"input":{
      headline: 'Mehraufwand Steuerberater',
      row1: {
        text: 'Pauschale',
        disabledCheck: false,
        icon: 'cash',
        vuexModule: 'Buchhaltung',
        stateObj: 'mehraufwand',
        value: 'pauschale',
        mutationName: 'Buchhaltung/updateMehraufwandPauschale'
      },
      row2: {
        text: '',
        disabledCheck: false,
        icon: 'cash',
        vuexModule: '',
        stateObj: '',
        value: '',
        mutationName: 'Buchhaltung/updateBankgebuehren'
      },
      row3: {
        text: '',
        disabledCheck: true,
        icon: 'clock',
        value: '',
        mutationName: ''
      },
      row4: {
        text: '',
        disabledCheck: true,
        icon: 'cash-stack',
        value: '',
        mutationName: ''
      },
      row5: {
        text: 'Kosten pro Beleg',
        disabledCheck: true,
        icon: 'cash',
        value: 'Buchhaltung/kostenBelegMehraufwandPauschale',
        mutationName: ''
      }
    }}}),_c('InputCard',{attrs:{"input":{
      headline:
        'Buchhaltungspunkt des Mahnwesen / Zahlungsunwilligkeit der Kassen',
      row1: {
        text: 'Mahnungen KT',
        disabledCheck: false,
        icon: 'exclamation-octagon',
        vuexModule: 'Buchhaltung',
        stateObj: 'mahnungen',
        value: 'kt',
        mutationName: 'Buchhaltung/updateMahnungKt'
      },
      row2: {
        text: 'Porto?',
        disabledCheck: false,
        icon: 'envelope',
        vuexModule: 'Buchhaltung',
        stateObj: 'mahnungen',
        value: 'porto',
        mutationName: 'Buchhaltung/updateMahnungPorto',
        rowFormat: 'currency'
      },
      row3: {
        text: '',
        disabledCheck: true,
        icon: 'clock',
        value: 'Buchhaltung/gesamtMinZahlungseingaenge',
        mutationName: ''
      },
      row4: {
        text: 'Gesamtkosten',
        disabledCheck: true,
        icon: 'cash-stack',
        value: 'Buchhaltung/gesamtKostenMahnung',
        mutationName: ''
      },
      row5: {
        text: 'Kosten pro Beleg',
        disabledCheck: true,
        icon: 'cash',
        value: 'Buchhaltung/kostenBelegMahnung',
        mutationName: ''
      }
    }}}),_c('InputCard',{attrs:{"input":{
      headline: 'Mehraufwand Buchhaltung durch Datenrückführung',
      row1: {
        text: 'Wie lange dauert die Lokalisierung & Verbuchung',
        disabledCheck: false,
        icon: 'clock-history',
        vuexModule: 'Buchhaltung',
        stateObj: 'datenrueckfuerung',
        value: 'lokalisierung',
        mutationName: 'Buchhaltung/updateLokalisierung'
      },
      row2: {
        text: 'Anzahl Buchungsvorgänge',
        disabledCheck: true,
        icon: 'file',
        vuexModule: 'Kostentraegermanagment',
        stateObj: 'erstellung',
        value: 'rechnungen',
        mutationName: ''
      },
      row3: {
        text: 'Gesamt min.',
        disabledCheck: true,
        icon: 'clock',
        value: 'Buchhaltung/gesamtMinDatenrueckfuehrung',
        mutationName: ''
      },
      row4: {
        text: 'Gesamtkosten',
        disabledCheck: true,
        icon: 'cash-stack',
        value: 'Buchhaltung/gesamtKostenDatenrueckfuehrung',
        mutationName: ''
      },
      row5: {
        text: 'Kosten pro Beleg',
        disabledCheck: true,
        icon: 'cash',
        value: 'Buchhaltung/kostenBelegDatenrueckfuehrung',
        mutationName: ''
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }